import { Navigate, Outlet, Route, Routes } from "react-router-dom";

import { ProcurementList } from "./procurement-list";
import { ProcurementView } from "./procurement-view";

export function Procurements() {
  return (
    <>
      <Routes>
        <Route index element={<Navigate replace to="list" />} />
        <Route element={<ProcurementList />} path="/list/*" />
        <Route element={<ProcurementView />} path="/:id" />
      </Routes>
      <Outlet />
    </>
  );
}
